import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import RegistrationContextProvider from "../context/registrationContext";
import SubmitRegisterContainer from "./SubmitRegisterContainer";

// import SubmitRegistrationOld from "./SubmitRegistrationOld";

export default function () {
    return (
        <RegistrationContextProvider>
            <GoogleReCaptchaProvider
                reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY!}
            >
                {/* <SubmitRegistrationOld /> */}
                <SubmitRegisterContainer />
            </GoogleReCaptchaProvider>
        </RegistrationContextProvider>
    );
}
